import 'bz-utilities/global';
import { cache } from 'tm3-core/cache';
import { AddBespokePlugins } from 'tm3-core/controls/plugin-util';

cache.app.plugin(
  () => cache.app.Caseflow,
  async () => {
    try {
      const manifest = await import('./src/plugin-manifest');
      AddBespokePlugins(manifest.default);
    } catch (e) {
      console.log('Error loading plugin manifest', e);
    }
  }
);

cache.app.plugin(
  () => cache.app.VHG,
  () => import('rehabworks-bespoke/entryPoint')
);

cache.app.plugin(
  () => cache.app.NH,
  () => import('nuffield-bespoke/entryPoint')
);
cache.app.plugin(
  () => cache.app.CBT,
  () => import('cbt-bespoke/entryPoint')
);
